import { User } from '@/types/user.type'

// Cookie name must match the one in middleware.ts
export const USER_DATA_COOKIE_NAME = '__user_data'

/**
 * Read user data from the cookie set by middleware
 * Returns the user object if found, null otherwise
 */
export function getUserDataFromCookie(): User | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const cookies = document.cookie.split(';')
    for (const cookie of cookies) {
      const [name, ...valueParts] = cookie.trim().split('=')
      if (name === USER_DATA_COOKIE_NAME) {
        const value = valueParts.join('=') // Handle values with '=' in them
        if (value) {
          const decoded = decodeURIComponent(value)
          return JSON.parse(decoded) as User
        }
      }
    }
  } catch (error) {
    console.error('Failed to parse user data cookie:', error)
  }

  return null
}

/**
 * Clear the user data cookie after reading
 * This prevents stale data from being used on subsequent navigations
 */
export function clearUserDataCookie(): void {
  if (typeof window === 'undefined') {
    return
  }

  // Set the cookie with an expired date to delete it
  document.cookie = `${USER_DATA_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`
}

/**
 * Get and clear user data cookie in one operation
 * This is the primary function to use in React Query initialData
 */
export function consumeUserDataCookie(): User | null {
  const userData = getUserDataFromCookie()
  if (userData) {
    clearUserDataCookie()
  }
  return userData
}
